import Observer from "../components/Observer";
import { ControllerSubject } from "../components/Subject";

const UPDATE_TYPE = {
    new: 'new',
    delete: 'delete',
    edit: 'edit'
}

class Board {
    constructor
    (
                id=-1, 
                title='', 
                type='', 
                orderIndex=-1,
                dateCreated='', 
                lastUpdated='', 
                hidden=false
    ) {
        this.id = parseInt(id);
        this.title = title;
        this.type = type;
        this.typeId = -1;
        this.orderIndex = orderIndex;
        this.dateCreated = dateCreated;
        this.lastUpdated = lastUpdated;
        this.hidden = hidden;
        this.updateCallback = false;
        this.data = {};
        this.observer = false;
        this.subject = new ControllerSubject();
    }

    initFromData(data = {
                    id: -1, 
                    title: '', 
                    type: '', 
                    orderIndex: -1,
                    dateCreated: '', 
                    lastUpdated: '', 
                    hidden: false
                }) {
                
        this.id = parseInt(data.id);
        this.title = data.title;
        this.type = data.type;

        if ( data.type.id && data.type.name ) {
            this.typeId = data.type.id;
            this.type = data.type.name;
        }

        this.orderIndex = data.orderIndex;
        this.dateCreated = data.dateCreated;
        this.lastUpdated = data.lastUpdated;
        this.hidden = data.hidden;
        this.data = {};
    }

    getTitle() {
        return this.title;
    }

    getHidden() {
        return this.hidden;
    }

    getSubject() {
        return this.subject;
    }

    // Adds an observer to the subject
    addObserver(observer=false) {
        if ( observer ) {
            this.subject.addObserver(observer);
        }
    }

    removeObserver(observer=false) {
        if ( observer ) {
            this.subject.removeObserver(observer);
        }
    }
    

    toggleVisibility(hidden=true) {
        this.hidden = hidden;
    }

    toFormObject() {
        return {
                id: this.id,
                title: this.title,
                type_id: this.typeId != -1 ? this.typeId : this.type,
                hidden: this.hidden,
        };
    }

    setUpdateCallback(newCallbackFn={}) {
        if ( !typeof newCallbackFn === 'function' ) {
            return false;
        }

        this.updateCallback = newCallbackFn;
    }

    update(type=UPDATE_TYPE.new, postData={}) {
        if ( this.updateCallback ) {
            this.updateCallback(postData);
        }
    }

    fetchData() {
    }

    setData(data={}) {
        this.data = data;
    }

    getData() {
        return this.data;
    }
}

export default Board;